import React from "react"
import { Link } from "gatsby"

export const Posts = ({posts}) => {
    return (
      <>
        {posts.map(({ node }) => {
          const title = node.frontmatter.title || node.fields.slug
          return (
            <article key={node.fields.slug} className="post-item">
              <h3>
                <Link to={node.fields.slug}>{title}</Link>
              </h3>
              <p
                dangerouslySetInnerHTML={{
                  __html: `${node.frontmatter.description || node.excerpt}`,
                }}
              ></p>
            </article>
          )
        })}
      </>
    )
}